import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  windowActive: false, // indica que a janela/tab está ativa (focada)
  isStandAlone: false, // indica que a aplicação esté sendo servida fora do site
  windowResizable: {
    visible: false,
    state: 'floating', // maximized, minimized, floating
    title: '',
    content: null,
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  }
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.WINDOW_ACTIVE:
      return {
        ...state,
        windowActive: action.active
      }
    case types.CHANGE_STAND_ALONE_MODE:
      return {
        ...state,
        windowActive: action.active
      }
    case types.CHANGE_WINDOW_RESIZABLE:
      return {
        ...state,
        windowResizable: {
          ...state.windowResizable,
          ...action.payload,
        }
      }
    default:
      return state
  }
}
